// import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import DateWedding from './components/DateWedding';
import ImageCouple from './components/ImageCouple';
import Location from './components/Location';
import floralTop from './assets/image/floral3.png';
import floralButtom from './assets/image/floral4.png';
// import Scenery from './assets/image/scenery1.jpg';
import View from './assets/image/view.jpg';
import Quote from './components/Quote';
import  Music from './components/SoundPlaying';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import Protocol from './components/Protocol';
// import { AnimateOnChange, AnimateGroup, HideUntilLoaded } from 'react-animation'
import { motion } from "framer-motion";

function App() {
  return (
    <div>
        <Navbar />
        <div id="home" className="relative bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto">
            <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
                <svg className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2" fill="currentColor" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
                    <polygon points="50,0 100,0 50,100 0,100" />
                </svg>
                {/* Don't remove this div. It's a placeholder for where the former navbar was. */}
                <div className="relative pt-6 px-4 sm:px-6 lg:px-8"></div>
                    <main className="mt-8 mx-auto max-w-7xl px-4 sm:mt-10 sm:px-6 md:mt-14 lg:mt-18 lg:px-8 xl:mt-26">
                        <div className="text-center mt-10 lg:mt-10">
                            {/* <h1 className="text-4xl tracking-tight font-Alexs text-gray-darkest sm:text-5xl md:text-6xl">
                                <div className="block">The, <span className="text-turquoise">Wedding</span></div>
                            </h1>
                            <p class="mt-3 text-base font-Alexs text-gray-darkest sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-1 md:text-xl lg:mx-0">
                                celebration
                            </p> */}
                            <motion.div 
                            animate={{ y: -50 }}
                            transition={{ ease: "easeOut", duration: 2 }}
                            className="flex justify-center -mb-16"
                            >
                              <img className="h-20 mb-3 sm:h-28 lg:h-36" src={floralTop} alt="floral-top"></img>
                            </motion.div>
                            <h1 className="text-4xl tracking-tight font-Alexs text-gray-darkest sm:text-5xl md:text-6xl md:mt-5">
                            <div className="block text-current text-bold">Amar &  <span className="text-current">Marwiyah</span></div>
                            </h1>
                            <motion.div 
                            animate={{ y: 50 }}
                            transition={{ ease: "easeOut", duration: 2 }}
                            className="flex justify-center -mt-16"
                            >
                              <img className="h-20 mt-3 sm:h-28 lg:h-36 mb-10" src={floralButtom} alt="floral-buttom"></img>
                            </motion.div>
                            <p className="mt-5 mb-10 text-bold font-Alexs text-gray-darkest lg:ml-3 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-1 md:text-xl lg:mx-0 md:mt-5 lg:mt-18">
                                Akan menikah
                            </p>
                            {/* <p class="text-1xl tracking-tight font-extrabold text-gray-darkest sm:text-2xl md:text-3xl pt-4 pb-6">There are <span class="text-turquoise">10</span> days left until your surf adventure!</p> */}
                        </div>
                    </main>
                </div>
            </div>
            <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                <img className="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full" src={View} alt="woman with surfboard at sunset"></img>
            </div>
        </div>
        <DateWedding />
        <ImageCouple />
        <Location />
        <Quote />
        <Music />
        <Gallery />
        <Protocol />
        <Footer />
    </div>
  );
}

export default App;
